// extracted by mini-css-extract-plugin
export var chip = "_cp-0";
export var filterDropdown = "_cp-5";
export var filterItem = "_cp-6";
export var icon = "_cp-1";
export var removeButton = "_cp-3";
export var removeIcon = "_cp-4";
export var separator = "_cp-2";